import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04156dcb"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row gap-2" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "video-overlay"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", null, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-play" })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  alt: "Youtube thumbnail",
  class: "video-image"
}
const _hoisted_9 = ["alt"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkButton = _resolveComponent("LinkButton")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.vm.subTitle?.replaceAll(' ', '_').toLowerCase(),
    class: _normalizeClass(["block", _ctx.blockBackgroundClass(_ctx.vm.backgroundColor)])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.hasVideo)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["col-12", _ctx.vm.imageSize === _ctx.size.large ? 'col-lg-6' : 'col-lg-4'])
            }, [
              (_ctx.showVideo)
                ? (_openBlock(), _createElementBlock("iframe", {
                    key: 0,
                    allowfullscreen: "",
                    height: "100%",
                    src: `https://www.youtube.com/embed/${_ctx.vm.youTubeId}?autoplay=1`,
                    style: {"min-height":"400px"},
                    type: "video/mp4",
                    width: "100%"
                  }, null, 8, _hoisted_4))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("button", {
                      class: "play-button",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPlayVideoClick && _ctx.onPlayVideoClick(...args)))
                    }, _hoisted_7),
                    _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
                      [_directive_lazy, `https://img.youtube.com/vi/${_ctx.vm.youTubeId}/maxresdefault.jpg`]
                    ])
                  ]))
            ], 2))
          : (_ctx.hasImage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["col-12 media-img", _ctx.vm.imageSize === _ctx.size.large ? 'col-lg-6' : 'col-lg-4'])
              }, [
                _withDirectives(_createElementVNode("img", {
                  alt: _ctx.vm.imageAlt
                }, null, 8, _hoisted_9), [
                  [_directive_lazy, _ctx.vm.imageUrl]
                ])
              ], 2))
            : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["col-lg mb-1", { 'order-lg-first': _ctx.vm.imagePosition !== _ctx.imagePosition.left }])
        }, [
          (_ctx.vm.subTitle)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("p", {
                  class: "lead mb-0",
                  innerHTML: _ctx.vm.subTitle
                }, null, 8, _hoisted_10),
                _createElementVNode("h2", {
                  class: "",
                  innerHTML: _ctx.vm.title
                }, null, 8, _hoisted_11)
              ], 64))
            : (_openBlock(), _createElementBlock("h2", {
                key: 1,
                class: "",
                innerHTML: _ctx.vm.title
              }, null, 8, _hoisted_12)),
          _createElementVNode("div", {
            class: "rte",
            innerHTML: _ctx.vm.text
          }, null, 8, _hoisted_13),
          (_ctx.vm.ctaLinkItem)
            ? (_openBlock(), _createBlock(_component_LinkButton, {
                key: 2,
                class: _normalizeClass(["mt-2", _ctx.ctaButtonClass(_ctx.vm.ctaLinkStyle) || 'p-button-raised p-button-text p-button-arrow']),
                label: _ctx.vm.ctaLinkItem.text,
                target: _ctx.vm.ctaLinkItem.target,
                title: _ctx.vm.ctaLinkItem.title,
                url: _ctx.vm.ctaLinkItem.url
              }, null, 8, ["class", "label", "target", "title", "url"]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ])
  ], 10, _hoisted_1))
}